import { render } from "./reviuRKA.vue?vue&type=template&id=619549ba"
import script from "./reviuRKA.vue?vue&type=script&lang=js"
export * from "./reviuRKA.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__